import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketingRoutingModule } from './marketing-routing.module';
import { MarketingComponent } from './marketing.component';
import { SocialMediaPostingComponent } from './social-media-posting/social-media-posting.component';
import { EmailMarketingComponent } from './email-marketing/email-marketing.component';
import { ContentCalendarComponent } from './content-calendar/content-calendar.component';
import { PostAnalyticsComponent } from './post-analytics/post-analytics.component';
import { FormsModule } from '@angular/forms';
import { CalendarContainerComponent, UbsViewContainersModule } from '@urbannex/view-containers';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MarketingCalendarComponent } from './marketing-calendar/marketing-calendar.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NbCardModule, NbLayoutModule } from '@nebular/theme';

@NgModule({
  declarations: [
    MarketingComponent,
    SocialMediaPostingComponent,
    EmailMarketingComponent,
    ContentCalendarComponent,
    PostAnalyticsComponent,
    MarketingCalendarComponent
  ],
  imports: [
    CommonModule,
    MarketingRoutingModule,
    FormsModule,
    CalendarContainerComponent,
    NgbModalModule,
    UbsViewContainersModule,
    NbLayoutModule,
    NbCardModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ]
})
export class MarketingModule { }
